var _style, _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClock4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1024 1024",
    style: {
      enableBackground: "new 0 0 1024 1024"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:63.7268;stroke-miterlimit:10;}\r\n\t.st1{stroke:#000000;stroke-width:44.4447;stroke-miterlimit:10;}\r\n")), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 512,
    cy: 512,
    r: 465.09
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M206.67,511.99c6.58-1.88,12.64-3.61,18.7-5.34c84.58-24.18,169.17-48.32,253.73-72.56 c20.13-5.77,39.9-5.3,58.94,3.64c26.68,12.52,42.7,33.58,47.23,62.71c6.39,41.07-20.79,80.97-61.26,90.78 c-13.52,3.28-27.07,3.46-40.48-0.25c-23.61-6.54-47.16-13.32-70.72-20.04c-52.32-14.94-104.64-29.92-156.95-44.87 C239.63,521.41,223.39,516.77,206.67,511.99z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock4);
export default __webpack_public_path__ + "static/media/clock4.b958e912e4f465955ec6a755c164e242.svg";
export { ForwardRef as ReactComponent };